import { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient, formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await apiClient.post("/auth/forgot-password", { email }); }
    catch {}
    finally { setSent(true); setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8] p-8">
      <div className="w-full max-w-md">
        <div className="mb-10"><Logo /></div>
        <div className="font-overline text-[#4A5568] mb-3">Password reset</div>
        <h1 className="font-serif text-4xl text-[#0A192F] tracking-tight mb-2">Forgot your password?</h1>
        <p className="text-[#4A5568] text-sm mb-8">
          Enter your email and we'll send you a reset link. Already remember it?{" "}
          <Link to="/login" className="underline" data-testid="link-back-login">Sign in</Link>
        </p>
        {sent ? (
          <div className="bg-white border border-[#0A192F]/10 rounded-sm p-6" data-testid="forgot-sent">
            <div className="font-serif text-lg text-[#0A192F] mb-2">Check your inbox</div>
            <p className="text-sm text-[#4A5568]">If an account exists for <strong>{email}</strong>, a reset link has been sent. The link expires in 1 hour.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
            <div>
              <Label className="text-xs uppercase tracking-[0.15em] font-bold text-[#4A5568]">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 rounded-sm bg-white" data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0A192F] hover:bg-[#0A192F]/90 rounded-sm" data-testid="forgot-submit">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
